export default "__VITE_ASSET__CK5jP5JL__"